module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-card', {
    staticClass: "box-card",
    attrs: {
      "header": "活动详情"
    }
  }, [_c('h1', [_vm._v(_vm._s(_vm.viewData.title))]), _vm._v(" "), _c('h2', [_vm._v("发布时间：" + _vm._s(_vm.viewData.publishDate) + "      浏览量：" + _vm._s(_vm.viewData.viewer))]), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.viewData.content)
    }
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ac18aa04","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/activity/View.vue
// module id = 1192
// module chunks = 2